import { css } from "lit";

import "@fontsource-variable/nunito";
import "./props.css";

export { colors } from "@pentacode/core";

// TODO: remove global config when refactoring shared style imports
export const config = css``;
